import { ETaskStatus } from '@constants';
import { IActivity } from '@sdk/contracts';
import { Flex, Switch } from 'antd';
import { useTranslation } from 'react-i18next';

import { useLocalCourse, useProfile } from '@/store';

type Props = {
  sectionId: string;
  activity: IActivity;
};

export const ToogleActivityActive: React.FC<Props> = ({ sectionId, activity }) => {
  const { t } = useTranslation('CourseTranslations');
  const { updateLocalActivity } = useLocalCourse();
  const {
    roleCheck: { isManager }
  } = useProfile();
  const isActive =
    isManager &&
    (!activity.task || activity.task.statusInfo.currentStatus === ETaskStatus.APPROVED);
  const tooltipTitle = activity.active ? t('PUBLISHED') : t('NOT_PUBLISHED');

  const handleChange = (active: boolean) =>
    updateLocalActivity(sectionId, {
      ...activity,
      active
    });

  return (
    <Flex gap={24} align="center" justify="space-between">
      <span>{tooltipTitle}</span>
      <Switch size="small" checked={activity.active} disabled={!isActive} onChange={handleChange} />
    </Flex>
  );
};
